import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/core/auth/guards/auth.guard';
import { AddEditGoogleCalendarServiceAccountComponent } from './add-edit-google-calendar-service-account/add-edit-google-calendar-service-account.component';
import { GoogleCalendarServiceAccountComponent } from './google-calendar-service-account.component';
import { GoogleCalenderExcelImportComponent } from './google-calender-excel-import/google-calender-excel-import.component';

const routes: Routes = [
  { path: '', component: GoogleCalendarServiceAccountComponent },

  {
    path: 'add-edit-google-calender/:googleCalenderId/:leadId',
    component: AddEditGoogleCalendarServiceAccountComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'add-edit-google-calender/:googleCalenderId',
    component: AddEditGoogleCalendarServiceAccountComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'import-xl',
    component: GoogleCalenderExcelImportComponent,
    canActivate: [AuthGuard]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GoogleCalendarServiceAccountRoutingModule { }
